{
    "MFA_Setup_Title": "Multi-Factor Authenticatie (MFA) instellen",
    "MFA_Login_Title": "Invoer MFA-code",
    "MFA_Setup_Description1": "Scan de QR-code hieronder met uw",
    "MFA_Setup_Description2": "authenticatie app.",
    "MFA_Setup_Description3": "Voer dan hier de code in die wordt weergegeven in je app.",
    "MFA_Login_Description3": "Voer de code van uw authenticator-app in om in te loggen.",
    "MFA_Login_Description": "Voer de code van uw authenticator-app in om in te loggen.",
    "MFA_Setup_Continue": "Volledige MFA-instelling",
    "MFA_Login_Continue": "Ga verder",
    "MFA_Setup_Cancel": "Annuleren",
    "MFA_Login_Cancel": "Afmelden",
    "MFA_Authenticator_Help": "**Wat is een authenticatie app?\nEen authenticatie-app is een mobiele app die een eenmalig wachtwoord (OTP) genereert dat u kunt\ngebruikt bij het inloggen op uw account.\n\n**Waarom heb ik een authenticator app nodig?\nEen authenticator app is een veiligere manier om in te loggen op uw account.\n\n**Hoe gebruik ik een authenticator app?**\nDownload een authenticator-app van de App Store of Google Play.####Open de app en scan de QR-code.####Voer de zescijferige code in die door de app wordt gegenereerd.####Klik op \"Complete MFA Setup\".####!",
    "MFA_SessionMissing_Error": "Cognito Sessie ontbreekt. Probeer het opnieuw.",
    "NAME": "MFALanguage"
}